import Api from "@/api/Api";
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      errors: {},
      isLoading: false,
      phase: "input"
    };
  },
  computed: {
    rawPostData() {
      return {};
    },
    validateMethod() {
      return "post";
    },
    validateUrl() {
      return "";
    },
    execMethod() {
      return "post";
    },
    execUrl() {
      return "";
    }
  },
  methods: {
    getScrollTop() : HTMLElement | null {
      return null;
    },
    async confirm() {
      this.errors = {};
      this.isLoading = true;
      const postData: Record<string, any> = {};
      for (const [k, v] of Object.entries(this.rawPostData)) {
        postData[k] = v;
      }
      const decorated = await this.decoratePostData(postData);

      try {
        await Api.singleton().call({
          method: this.validateMethod.toUpperCase(),
          resource: this.validateUrl,
          body: decorated
        });
        this.phase = "confirm";
      } catch (violations) {
        for (const v of violations as {propertyPath: string, message:string}[]) {
          this.$set(this.errors, v.propertyPath, v.message);
        }
      }
      this.isLoading = false;
    },
    async exec() {
      this.errors = {};
      this.isLoading = true;
      const postData: Record<string, any> = {};
      for (const [k, v] of Object.entries(this.rawPostData)) {
        postData[k] = v;
      }
      const decorated = await this.decoratePostData(postData);

      try {
        const res = await Api.singleton().call({
          method: this.execMethod.toUpperCase(),
          resource: this.execUrl,
          body: decorated
        });
        await this.onComplete(res);
      } catch (ex) {
        alert("登録時にエラーが発生しました");
      }
      this.isLoading = false;
    },
    decoratePostData(postData: Record<string, any>) {
      return postData;
    },
    onComplete(res: unknown) {
      return;
    }
  }
});
